






	// @ts-ignore
    import _ from './MNotice.ts'; export default _;
